var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAirDistributionDiffuse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / DiffusePosition--normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: -7.77156117e-16,
    y: 0,
    width: 48,
    height: 43
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons---\\u2660\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-DiffusePosition--normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    mask: "url(#mask-2)",
    x: 15,
    y: 21,
    width: 18,
    height: 28,
    rx: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    mask: "url(#mask-2)",
    cx: 24,
    cy: 11,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,16 C48,19.313875 45.313875,22 42,22 C38.686125,22 36,19.313875 36,16 C36,12.686125 38.686125,10 42,10 C45.313875,10 48,12.686125 48,16 Z",
    id: "circle",
    fill: "#CCCCCC",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16 C12,19.313875 9.313875,22 6,22 C2.686125,22 0,19.313875 0,16 C0,12.686125 2.686125,10 6,10 C9.313875,10 12,12.686125 12,16 Z",
    id: "circle",
    fill: "#CCCCCC",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 10.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-dummy-icon",
    stroke: "#FF6666",
    strokeDasharray: "2,3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L44,44",
    id: "Line",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L44,44",
    id: "Line-Copy",
    strokeWidth: 2,
    transform: "translate(22.000000, 22.000000) scale(-1, 1) translate(-22.000000, -22.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAirDistributionDiffuse);
export default __webpack_public_path__ + "static/media/icon-air_distribution_diffuse.c6227dbc0e69af2c804e941e703645cc.svg";
export { ForwardRef as ReactComponent };